import printJS from "print-js";

export const printPdf = (pdfBaseUrl : string) => {
    const data = pdfBaseUrl.replace("data:application/octet-stream;base64,", "");
    printJS({printable: data, type: 'pdf', base64: true})

}